export const CONSULTED_SOURCES = 'consultedSources'
export const ZOHO_INTERNALL_CALL = 'zohoInternalCall'
export const READ_ARTICLE = 'readArticle'
export const FIRST_WORD_FEEDBACK = 'firstwordAiFeedback'
export const DEBUG_FF = 'debug'
export const ONBOARDING_DEBUG = 'onboardingDebug'
export const RELATED_PROMPTS = 'relatedPrompts'
export const RELATED_REPORTS = 'relatedReports'
export const RELATED_PROMPTS_STORY = 'relatedPromptsStory'
export const STORY_PAGE_TAGS = 'storyPageTags'
